/**
 * Vurgu rengi seçici: hazır renkler + özel renk.
 *
 * Kullanıcıya tek bir renk sorulur; düğme, odak halkası ve seçili satır tonları bundan
 * türetilir (bkz. lib/accentColor). Dört tonu ayrı ayrı seçtirmek hem zahmetli hem de
 * birbirini tutmayan sonuçlar veriyordu.
 */
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { cn } from '@/shared/lib/cn';
import { ACCENT_PRESETS, isValidHex } from '@/entities/preferences/lib/accentColor';

export interface AccentPickerProps {
  value: string;
  onChange: (hex: string) => void;
}

export function AccentPicker({ value, onChange }: AccentPickerProps) {
  const { t } = useTranslation();
  const current = value.toLowerCase();

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {ACCENT_PRESETS.map((p) => {
        const selected = current === p.value.toLowerCase();
        return (
          <button
            key={p.value}
            type="button"
            title={t(`prefs.accent.${p.name}`)}
            aria-label={t(`prefs.accent.${p.name}`)}
            aria-pressed={selected}
            onClick={() => onChange(p.value)}
            className={cn(
              'flex h-6 w-6 items-center justify-center rounded-full border transition-transform',
              selected ? 'border-fg scale-110' : 'border-border hover:scale-105',
            )}
            style={{ backgroundColor: p.value }}
          >
            {selected ? <Check className="h-3.5 w-3.5 text-white drop-shadow" /> : null}
          </button>
        );
      })}
      {/* Özel renk: tarayıcının kendi seçicisi — ayrı bir bileşen taşımaya değmez. */}
      <label
        className="ml-1 flex h-6 cursor-pointer items-center gap-1 rounded-md border border-border px-2 text-xs text-fg-muted hover:bg-bg-hover"
        title={t('prefs.accent.custom')}
      >
        <span
          className="h-3 w-3 rounded-full border border-border-strong"
          style={{ backgroundColor: isValidHex(value) ? value : undefined }}
          aria-hidden="true"
        />
        {t('prefs.accent.custom')}
        <input
          type="color"
          value={isValidHex(value) ? value : '#10b981'}
          onChange={(e) => onChange(e.target.value)}
          className="sr-only"
          aria-label={t('prefs.accent.custom')}
        />
      </label>
    </div>
  );
}
